module.exports = __webpack_public_path__ + "static/media/theme-classic.a32d7a68.png";